import React, { useEffect, useState, createElement } from 'react';
import { Calendar, CheckCircle, Users, ArrowRight, Star, Clock, Zap } from 'lucide-react';
import { Footer } from '../components/Footer';
import { VslHeader } from '../components/VslHeader';
declare global {
  interface Window {
    fbq: any;
  }
}
export function VipCallsPage() {
  const [showSurvey, setShowSurvey] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
    // Load GHL form embed script
    const formScript = document.createElement('script');
    formScript.src = 'https://link.msgsndr.com/js/form_embed.js';
    formScript.async = true;
    document.head.appendChild(formScript);
    return () => {
      if (document.head.contains(formScript)) document.head.removeChild(formScript);
    };
  }, []);
  // Get next Wednesday
  const getNextWednesday = () => {
    const now = new Date();
    const estTime = new Date(now.toLocaleString('en-US', {
      timeZone: 'America/New_York'
    }));
    const currentDay = estTime.getDay();
    const currentHour = estTime.getHours();
    let daysUntilWed = 0;
    if (currentDay === 3) {
      daysUntilWed = currentHour >= 19 ? 7 : 0;
    } else if (currentDay < 3) {
      daysUntilWed = 3 - currentDay;
    } else {
      daysUntilWed = 7 - currentDay + 3;
    }
    const nextWed = new Date(estTime);
    nextWed.setDate(estTime.getDate() + daysUntilWed);
    const day = nextWed.getDate();
    const month = nextWed.toLocaleString('es-ES', {
      month: 'long'
    }).toUpperCase();
    return `${month} ${day}`;
  };
  return <div className="min-h-screen bg-black text-white font-sans" data-id="element-5408" data-mp="2k4101sittasq">
      {/* Header */}
      <VslHeader data-id="element-5409" data-mp="26517i9s70bra" />

      {/* Hero Section */}
      <section className="pt-20 md:pt-28 pb-12 md:pb-16 bg-gradient-to-b from-gray-900 to-black" data-id="element-5410" data-mp="2636o4zwkkrpb">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-5411" data-mp="2b5fgpv5j5rqw">
          {/* VIP Badge */}
          <div className="flex justify-center mb-6" data-id="element-5412" data-mp="1x5egmhx3aoch">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[#FDB931]/20 to-[#D68E15]/20 border border-[#FDB931]/50 rounded-full px-5 py-2" data-id="element-5413" data-mp="215ojhlpl4yn4">
              <Star className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-5414" data-mp="3rivvlgjficvw" />
              <span className="text-sm md:text-base font-bold text-[#FDB931] uppercase tracking-wider" data-id="element-5415" data-mp="3vio9m8rldb8n">
                Acceso VIP Exclusivo
              </span>
              <Star className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-5416" data-mp="1fuqzjtmhajj7" />
            </div>
          </div>

          {/* Main Headline */}
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-4 leading-tight text-center tracking-tight" data-id="element-5417" data-mp="1tn7797qbr5qg">
            Llamadas Semanales VIP con{' '}
            <span className="text-[#FDB931]" data-id="element-5418" data-mp="23jtt9zue02u2">Gabriel Beltrán</span>
          </h1>

          <p className="text-lg md:text-xl text-gray-300 text-center mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-5419" data-mp="1yl8qptrnx72g">
            Estrategia avanzada en vivo, cada miércoles. Donde los emprendedores
            serios construyen, escalan y dominan con IA.
          </p>

          {/* Schedule Banner */}
          <div className="bg-gradient-to-r from-[#FDB931]/10 to-[#D68E15]/10 border border-[#FDB931]/30 rounded-2xl p-5 md:p-6 mb-8 text-center" data-id="element-5420" data-mp="i70i733q8y9t">
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-5421" data-mp="d97csca908al">
              <Calendar className="w-5 h-5 text-[#FDB931]" data-id="element-5422" data-mp="fn3u3q6g1yl8" />
              <p className="text-[#FDB931] font-bold text-lg md:text-xl uppercase tracking-wide" data-id="element-5423" data-mp="fondhpnecpr8">
                Cada Miércoles — 7:00 PM EST (Hora Miami)
              </p>
            </div>
            <p className="text-gray-400 text-sm" data-id="element-5424" data-mp="ol61cngrtngy">
              Próxima llamada: {getNextWednesday()}
            </p>
          </div>

          {/* VIP Highlight Box */}
          <div className="bg-gradient-to-r from-[#FDB931]/10 to-amber-900/30 rounded-2xl p-6 md:p-8 border-2 border-[#FDB931]/40 mb-8 shadow-2xl" data-id="element-5425" data-mp="3s5aesozvizwy">
            <div className="flex items-start gap-4 mb-4" data-id="element-5426" data-mp="5wrbi3i6wfhq">
              <Zap className="w-6 h-6 md:w-7 md:h-7 text-[#FDB931] flex-shrink-0 mt-1" data-id="element-5427" data-mp="5v6gkcryqujc" />
              <div data-id="element-5428" data-mp="ao9cuso4ki38">
                <h2 className="text-xl md:text-2xl font-bold text-white mb-3" data-id="element-5429" data-mp="aosipb0i3g0w">
                  Esto No Es Un Curso Más — Es Tu Mesa de Estrategia Semanal
                </h2>
                <p className="text-base md:text-lg text-gray-100 leading-relaxed" data-id="element-5430" data-mp="3eb9p0kqwgn8q">
                  Cada miércoles, Gabriel Beltrán se conecta en vivo con un
                  grupo reducido de emprendedores comprometidos. Aquí no hay
                  teoría — hay decisiones reales, feedback directo y estrategia
                  avanzada para escalar tu negocio digital con IA.
                </p>
              </div>
            </div>
          </div>

          {/* Plan Options */}
          <div className="grid md:grid-cols-2 gap-6 mb-10" data-id="element-5431" data-mp="2nufn9agf77ub">
            {/* 3 Month Plan */}
            <div className="bg-gray-800/50 rounded-xl p-6 border border-gray-700 hover:border-[#FDB931]/40 transition-colors" data-id="element-5432" data-mp="2j37emgmwzqi7">
              <div className="flex items-center gap-2 mb-4" data-id="element-5433" data-mp="2e4w5670j7i0i">
                <Clock className="w-5 h-5 text-[#FDB931]" data-id="element-5434" data-mp="295t9veacsq5q" />
                <h3 className="text-lg font-bold text-white" data-id="element-5435" data-mp="2936u4rdb74cf">Plan 3 Meses</h3>
              </div>
              <p className="text-gray-300 text-sm mb-4" data-id="element-5436" data-mp="248aylh8v5yuk">
                Ideal para emprendedores que quieren validar y lanzar su
                producto digital con acompañamiento semanal directo.
              </p>
              <ul className="space-y-2" data-id="element-5437" data-mp="1uikue1a0hyny">
                {['12 llamadas en vivo con Gabriel', 'Acceso al grupo VIP privado', 'Feedback directo sobre tu negocio', 'Estrategias de lanzamiento y escalamiento'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm" data-id="element-5438" data-mp="1lhmotejxdj39" data-mpi={i}>
                    <CheckCircle className="w-4 h-4 text-[#FDB931] flex-shrink-0 mt-0.5" data-id="element-5439" data-mp="1lk0jhmap0taa" />
                    <span className="text-gray-200" data-id="element-5440" data-mp="298a78trgvr42">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* 6 Month Plan */}
            <div className="relative bg-gray-800/50 rounded-xl p-6 border-2 border-[#FDB931]/50" data-id="element-5441" data-mp="1zigys1mmfs41">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#FDB931] text-black text-xs font-black px-4 py-1 rounded-full uppercase tracking-wider" data-id="element-5442" data-mp="24fyxz0au6syu">
                ⭐ Más Popular
              </div>
              <div className="flex items-center gap-2 mb-4 mt-1" data-id="element-5443" data-mp="2wxuvns6e3gkq">
                <Clock className="w-5 h-5 text-[#FDB931]" data-id="element-5444" data-mp="36bd4ks74hklh" />
                <h3 className="text-lg font-bold text-white" data-id="element-5445" data-mp="369s990czhxmk">Plan 6 Meses</h3>
              </div>
              <p className="text-gray-300 text-sm mb-4" data-id="element-5446" data-mp="32a1e6kgfcvc8">
                Para emprendedores serios que quieren transformación completa —
                desde el lanzamiento hasta la escala real de su negocio.
              </p>
              <ul className="space-y-2" data-id="element-5447" data-mp="2nd0r4u96hok3">
                {['24 llamadas en vivo con Gabriel', 'Acceso al grupo VIP privado', 'Revisión de campañas y embudos', 'Estrategia avanzada de escalamiento', 'Prioridad en preguntas y feedback', 'Acceso a grabaciones de todas las sesiones'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm" data-id="element-5448" data-mp="2x8u42eqt7k2e" data-mpi={i}>
                    <CheckCircle className="w-4 h-4 text-[#FDB931] flex-shrink-0 mt-0.5" data-id="element-5449" data-mp="2saiwkanzllnc" />
                    <span className="text-gray-200" data-id="element-5450" data-mp="cjeh5uupofi1">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* What You Get */}
          <div className="bg-gray-800/50 rounded-xl p-6 md:p-8 border border-gray-700 mb-10" data-id="element-5451" data-mp="222w7pleft2pv">
            <h3 className="text-lg md:text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-5452" data-mp="2636prwfi7jl3">
              <Users className="w-6 h-6 text-[#FDB931]" data-id="element-5453" data-mp="2b29ichearxc6" />
              ¿Qué Obtienes en las Llamadas VIP?
            </h3>
            <div className="space-y-3" data-id="element-5454" data-mp="2fu9pouwp5sis">
              {['Estrategia en vivo con Gabriel Beltrán cada miércoles a las 7PM EST', 'Feedback directo sobre tu producto, embudo y campañas', 'Acceso a un grupo exclusivo de emprendedores de alto nivel', 'Resolución de problemas en tiempo real — sin esperar semanas', 'Networking con otros emprendedores serios que están ejecutando', 'Grabaciones disponibles si no puedes asistir en vivo'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-5455" data-mp="2yq9i26tl6y2w" data-mpi={i}>
                  <CheckCircle className="w-5 h-5 text-[#FDB931] flex-shrink-0 mt-0.5" data-id="element-5456" data-mp="zgjihfaa6o4x" />
                  <span className="text-gray-200 text-sm md:text-base" data-id="element-5457" data-mp="14fdyyaks00lv">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-6 md:py-8 bg-black" data-id="element-5458" data-mp="s2sfrdc91zo4">
        <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-5459" data-mp="n4h20riu350m">
          <p className="text-gray-400 text-sm mb-4 uppercase tracking-wider" data-id="element-5460" data-mp="i5xisyvmk7by">
            Cupos limitados — Solo aceptamos emprendedores comprometidos
          </p>

          <button onClick={() => setShowSurvey(true)} className="group relative w-full max-w-xl mx-auto bg-gradient-to-b from-[#FDB931] to-[#D68E15] hover:from-[#FFC54D] hover:to-[#E6A02E] text-black font-black text-lg md:text-xl lg:text-2xl uppercase tracking-wide rounded-xl py-5 px-6 shadow-[0_0_30px_rgba(253,185,49,0.3)] transition-all duration-300 transform hover:scale-[1.02] flex items-center justify-center gap-3" data-id="element-5461" data-mp="1ft60eisi8w8o">
            APLICAR PARA LAS LLAMADAS VIP
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-5462" data-mp="3mjvwg4sdmxd4" />
            <div className="absolute inset-0 rounded-xl overflow-hidden pointer-events-none" data-id="element-5463" data-mp="2fxdr02flf5rf">
              <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-[#00D9FF]/60 to-transparent skew-x-[-25deg] group-hover:animate-shine" data-id="element-5464" data-mp="2bx3jumg2e9az" />
            </div>
          </button>

          {/* Trust Indicators */}
          <div className="mt-10 text-center" data-id="element-5465" data-mp="2kv5gkpsrmfsg">
            <div className="inline-flex items-center gap-2 bg-gray-800/50 border border-gray-700 rounded-full px-6 py-3" data-id="element-5466" data-mp="2zld2jfhzegxw">
              <CheckCircle className="w-5 h-5 text-[#FDB931]" data-id="element-5467" data-mp="2um9xhv204apx" />
              <span className="text-gray-200 text-sm md:text-base" data-id="element-5468" data-mp="38mkrh6yly5fb">
                100% Confidencial • Cupos Limitados • Grupo Exclusivo
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Who Is This For */}
      <section className="py-12 md:py-16 bg-gradient-to-b from-black to-gray-900" data-id="element-5469" data-mp="1e91vi1k86uw4">
        <div className="container mx-auto px-4 max-w-3xl" data-id="element-5470" data-mp="19b0b9db2cpj2">
          <div className="bg-gradient-to-r from-gray-800 to-gray-900 rounded-2xl p-6 md:p-8 border border-gray-700" data-id="element-5471" data-mp="3kxc1fn5862ot">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-4 text-center" data-id="element-5472" data-mp="3pwev6bfr8mhh">
              ¿Para Quién Son las Llamadas VIP?
            </h3>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-5473" data-mp="3c2nrhjopfwto">
              <div className="space-y-3" data-id="element-5474" data-mp="3g5agzdxwl5np">
                <div className="flex items-start gap-3" data-id="element-5475" data-mp="3g3zb98kwdnty">
                  <div className="bg-[#FDB931]/20 rounded-full p-2 flex-shrink-0" data-id="element-5476" data-mp="325j97uxzcli5">
                    <CheckCircle className="w-4 h-4 text-[#FDB931]" data-id="element-5477" data-mp="375xe544abfby" />
                  </div>
                  <div data-id="element-5478" data-mp="2t6eb2pqbyu6i">
                    <p className="font-semibold text-white text-sm" data-id="element-5479" data-mp="2t77h1ohgtfnl">
                      Emprendedores que ya están ejecutando
                    </p>
                    <p className="text-gray-300 text-xs" data-id="element-5480" data-mp="rej8r0pys20y">
                      No es para curiosos — es para los que hacen
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-5481" data-mp="24d1nk0epi22m">
                  <div className="bg-[#FDB931]/20 rounded-full p-2 flex-shrink-0" data-id="element-5482" data-mp="24emivs8uhp1j">
                    <CheckCircle className="w-4 h-4 text-[#FDB931]" data-id="element-5483" data-mp="1zcx4c2meyt8p" />
                  </div>
                  <div data-id="element-5484" data-mp="1vblfw0fa0e23">
                    <p className="font-semibold text-white text-sm" data-id="element-5485" data-mp="1vcwqaj388k26">
                      Personas que valoran el tiempo
                    </p>
                    <p className="text-gray-300 text-xs" data-id="element-5486" data-mp="2n3b126fy1g9m">
                      Feedback directo, sin rodeos
                    </p>
                  </div>
                </div>
              </div>
              <div className="space-y-3" data-id="element-5487" data-mp="2eb8z23q87rx8">
                <div className="flex items-start gap-3" data-id="element-5488" data-mp="2e9xysdvzp2av">
                  <div className="bg-[#FDB931]/20 rounded-full p-2 flex-shrink-0" data-id="element-5489" data-mp="29ce8ugpxj133">
                    <CheckCircle className="w-4 h-4 text-[#FDB931]" data-id="element-5490" data-mp="29abj7xsov9yw" />
                  </div>
                  <div data-id="element-5491" data-mp="36td09ww0i8hn">
                    <p className="font-semibold text-white text-sm" data-id="element-5492" data-mp="3213d2oma7mj2">
                      Quienes buscan escalar con IA
                    </p>
                    <p className="text-gray-300 text-xs" data-id="element-5493" data-mp="39dj2o04z9qw3">
                      Estrategia avanzada cada semana
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-5494" data-mp="3j92vgdo8w9gm">
                  <div className="bg-[#FDB931]/20 rounded-full p-2 flex-shrink-0" data-id="element-5495" data-mp="3nbr68qwirqg8">
                    <CheckCircle className="w-4 h-4 text-[#FDB931]" data-id="element-5496" data-mp="3n9mwhsbxvx81" />
                  </div>
                  <div data-id="element-5497" data-mp="3s8q0rak3hzey">
                    <p className="font-semibold text-white text-sm" data-id="element-5498" data-mp="14j3zxgwbzof">
                      Emprendedores que quieren comunidad
                    </p>
                    <p className="text-gray-300 text-xs" data-id="element-5499" data-mp="5vrgx3hfq36c">
                      Rodearte de los mejores acelera todo
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer data-id="element-5500" data-mp="jw27s6iqvhri" />

      {/* Floating WhatsApp Button */}
      <a href="http://wa.link/holagabriel" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#20BD5A] w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center shadow-lg shadow-[#25D366]/30 hover:scale-110 transition-all duration-300" aria-label="Chat on WhatsApp" data-id="element-5501" data-mp="68a7meacxbm3">
        <svg className="w-8 h-8 md:w-9 md:h-9 text-white" viewBox="0 0 24 24" fill="currentColor" data-id="element-5502" data-mp="b01pm0fg690m">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-5503" data-mp="3jfv64f9s3kho" />
        </svg>
      </a>

      {/* Survey Modal */}
      {showSurvey && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={() => setShowSurvey(false)} data-id="element-5504" data-mp="2vk9yf5z6afe3">
          <div className="relative w-full max-w-2xl bg-[#111] border border-[#FDB931]/30 rounded-2xl shadow-[0_0_30px_rgba(253,185,49,0.15)] p-4 md:p-6" onClick={e => e.stopPropagation()} data-id="element-5505" data-mp="30ggu85xuuaib">
            <button onClick={() => setShowSurvey(false)} className="absolute top-3 right-3 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors" data-id="element-5506" data-mp="3t073vmmpbfw5">
              ✕
            </button>
            <div className="w-full rounded-xl overflow-hidden" style={{
          minHeight: '500px'
        }} data-id="element-5507" data-mp="3sw5il0ds3u8x">
              <iframe src="https://api.leadconnectorhq.com/widget/survey/y25LzbmJtTRp1ZfZ0sY8" style={{
            border: 'none',
            width: '100%',
            height: '600px'
          }} scrolling="no" id="y25LzbmJtTRp1ZfZ0sY8" title="survey" data-id="element-5508" data-mp="3nydjnmepv7v8" />
            </div>
          </div>
        </div>}
    </div>;
}